<footer class="app-footer">
  <div class="footer-left">
    <i class="pi pi-wallet footer-logo-icon"></i>
    <span class="footer-brand">SmartPay</span>
    <span class="footer-sep">·</span>
    <span class="footer-copy">&copy; {{ currentYear }} All rights reserved.</span>
  </div>

  <div class="footer-right">
    <span class="footer-version">v1.0.0</span>
    <span class="footer-sep">·</span>
    <a href="#" class="footer-link" (click)="$event.preventDefault()">Privacy Policy</a>
    <span class="footer-sep">·</span>
    <a href="#" class="footer-link" (click)="$event.preventDefault()">Support</a>
  </div>
</footer>
